export enum LoginType{
    Mobile = 0,
    Web = 1,
    CAB = 2
}
